import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Proposal Cruise Vilamoura · Private Yacht · Morningstar";
const DESC = "Propose at sea in Vilamoura aboard Morningstar — private sunset yacht, Champagne, optional photographer, rose petals and a coordinated moment in the Algarve.";
const PATH = "/proposal-cruise-vilamoura";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/proposal-cruise-vilamoura")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Proposal Cruise · Vilamoura · Algarve",
        title: "Propose at sea in Vilamoura aboard ",
        titleAccent: "Morningstar.",
        sub: "A private sunset, Champagne on ice, an optional photographer and a captain who knows exactly when to slow the boat. We choreograph the moment, you live it.",
        ctaPrimary: "View proposal cruises",
        ctaSecondary: "Plan my proposal",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "proposal cruise Vilamoura, marriage proposal boat Algarve, propose at sea Portugal, engagement cruise Vilamoura",
      altPath: { en: PATH, pt: "/pt/cruzeiro-pedido-casamento-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Vilamoura Proposal Cruise",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Proposal Cruise Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});
